export default {"src":"/_next/static/media/icon-spotify.0367a78d.svg","height":75,"width":75};